import {
  DEFAULT_LOCALE,
  LOCALE_STORAGE_KEY,
  type AppLocale,
  type TranslationParams,
  type TranslationTree,
} from './locale.model';
import { TRANSLATIONS } from './translations';

function readLocale(): AppLocale {
  if (typeof localStorage === 'undefined') {
    return DEFAULT_LOCALE;
  }
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (stored === 'pt-BR' || stored === 'en' || stored === 'es-ES') {
    return stored;
  }
  return DEFAULT_LOCALE;
}

function lookup(tree: TranslationTree | undefined, key: string): string | undefined {
  const parts = key.split('.');
  let node: string | TranslationTree | undefined = tree;
  for (const part of parts) {
    if (node == null || typeof node === 'string') {
      return undefined;
    }
    node = node[part];
  }
  return typeof node === 'string' ? node : undefined;
}

function interpolate(template: string, params?: TranslationParams): string {
  if (!params) {
    return template;
  }
  return template.replace(/\{\{(\w+)\}\}/g, (_, name: string) => {
    const value = params[name];
    return value == null ? '' : String(value);
  });
}

/** Tradução fora do contexto de injeção Angular (ex.: métodos estáticos). */
export function translateStatic(
  key: string,
  params?: TranslationParams,
  locale?: AppLocale,
): string {
  const activeLocale = locale ?? readLocale();
  const current = lookup(TRANSLATIONS[activeLocale], key);
  if (current != null) {
    return interpolate(current, params);
  }
  const fallback = lookup(TRANSLATIONS[DEFAULT_LOCALE], key);
  if (fallback != null) {
    return interpolate(fallback, params);
  }
  return key;
}
